import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { SrFaxManagementApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting: GridSortItem[];
  active?: boolean;
  archive?: boolean;
  faxNumber?: string;
  searchString?: string;
  xTENANTID?: string;
}

/**
 * @author [atish bagate]
 * @description [This hook is used to fetch the fax outgoing list]
 *
 * @param {DGT_Pagination} pagination - The pagination object
 * @param {GridSortItem[]} gridSorting - The grid sorting object
 * @param {boolean} active - The active status
 * @param {boolean} archive - The archive status
 * @param {string} searchString - The search string
 * @param {string} xTENANTID - The xTENANTID
 * @returns {useBaseContent<any>} - The fax outgoing list
 */
export const useFaxOutgoingList = ({
  pagination,
  gridSorting,
  active,
  archive,
  searchString,
  faxNumber,
  xTENANTID,
}: Props): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortDirect = undefined;
  const sortBy = "modified";

  return useQuery({
    queryKey: [
      "fax-outgoing-list",
      pageIndex,
      pageSize,
      gridSorting,
      active,
      archive,
      searchString,
      faxNumber,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!xTENANTID,
    queryFn: async () =>
      await new SrFaxManagementApi(getConfigObject())
        .getAllFaxes(
          pageIndex,
          pageSize,
          sortBy,
          sortDirect,
          archive,
          faxNumber,
          searchString,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
